export const productEntityType = 'product'
